import { useContext } from 'react';

import { EditableEvent } from 'types/event.types';

import { EventEditorContext } from '../EventEditorProvider';

export const useEditableEvent = (): EditableEvent => {
  const event = useContext(EventEditorContext);
  if (!event) {
    throw new Error('useEditableEvent must be used within an EventEditorProvider');
  }
  return event;
};
